import { SectionWrapper } from '../../components/SectionWrapper';

import styles from './PressHeroSection.module.css';

export function PressHeroSection() {
  return (
    <SectionWrapper background="white" data-testid="press-section-hero">
      <div className={styles.section}>
        <p className={styles.eyebrow}>PRESS</p>
        <h1 className={styles.title}>Kudu in the news</h1>
        <p className={styles.subhead}>
          Coverage of Kudu and its university collaborators — exploring how
          human-centered AI is reshaping teaching, learning, and course materials
          in higher education.
        </p>
      </div>
    </SectionWrapper>
  );
}
